import { generatePath } from "react-router-dom";

// Every protected route is mounted under the language as `/:type/<path>`
// (components/routes/index.js), so a crumb URL is built the same way.
export function buildRouteUrl(routePath, params) {
  try {
    return generatePath(`/:type/${routePath}`, params);
  } catch {
    return null;
  }
}

export function stripTrailingSlash(pathname) {
  return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}
